<template>
    <main id="content" class="content-default contact-content">
        <div class="container">
            <div class="relative-section">
                <div class="brecrump font-bai">
                    <router-link to="/">{{ $t("app.Home") }}</router-link> /
                    <b>{{ $t("app.Contact Us") }}</b>
                </div>
            </div>
            <div class="contact-image text-center">
                <img src="../assets/images/contactus.png" alt="" />
            </div>
            <h1 class="text-center font-balo font-bold">
                {{ $t("app.Contact Us") }}
            </h1>
            <ValidationObserver v-slot="{ handleSubmit, reset }" ref="form">
                <form
                    action=""
                    id="contactForm"
                    class="form-default"
                    @reset.prevent="reset"
                    @submit.prevent="handleSubmit(onSubmit)"
                >
                    <div class="form-group" v-click-outside="clickOutSite">
                        <validation-provider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <div
                                class="select-custom font-bai"
                                :class="{
                                    'is-invalid': errors[0],
                                    active: isOpenDopdown === 'campings'
                                }"
                            >
                                <a
                                    href=""
                                    @click.prevent="
                                        setIsOpenDropdown('campings')
                                    "
                                    class="current"
                                    >{{
                                        contact_camping
                                            ? contact_camping
                                            : $t("app.Campings Clubs")
                                    }}</a
                                >
                                <slide-up-down
                                    :active="isOpenDopdown === 'campings'"
                                    tag="ul"
                                    :duration="100"
                                >
                                    <li
                                        v-for="(item, index) in campingClubs"
                                        :key="index"
                                    >
                                        <a
                                            href="#"
                                            @click.prevent="
                                                onSelectCamping(item)
                                            "
                                            >{{ item.title.rendered }}</a
                                        >
                                    </li>
                                </slide-up-down>
                                <input
                                    type="hidden"
                                    name="contact_camping"
                                    v-model="contact_camping"
                                />
                            </div>

                            <!-- <select
                                name="camping"
                                class="form-control"
                                v-model="contact_camping"
                                :class="{ 'is-invalid': errors[0] }"
                            >
                                <option value="">{{
                                    $t("app.Campings Clubs")
                                }}</option>
                                <option
                                    :value="item.title.rendered"
                                    v-for="(item, index) in campingClubs"
                                    :key="index"
                                    >{{ item.title.rendered }}</option
                                >
                            </select> -->
                        </validation-provider>
                    </div>
                    <div class="form-group">
                        <validation-provider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="$t('app.Enter name')"
                                v-model="contact_name"
                                :class="{ 'is-invalid': errors[0] }"
                            />
                        </validation-provider>
                    </div>
                    <div class="form-group">
                        <validation-provider
                            rules="required|email"
                            v-slot="{ errors }"
                        >
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="$t('app.Enter email')"
                                v-model="contact_email"
                                :class="{ 'is-invalid': errors[0] }"
                            />
                        </validation-provider>
                    </div>
                    <div class="form-group">
                        <validation-provider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <textarea
                                name=""
                                cols="30"
                                rows="10"
                                class="form-control"
                                :placeholder="$t('app.Your message')"
                                v-model="contact_message"
                                :class="{ 'is-invalid': errors[0] }"
                            ></textarea>
                        </validation-provider>
                    </div>
                    <div class="form-submit text-right">
                        <vue-recaptcha
                            ref="recaptcha"
                            @verify="onCaptchaVerified"
                            @expired="resetRecaptcha"
                            :sitekey="siteKey"
                            :loadRecaptchaScript="true"
                        ></vue-recaptcha>
                        <button type="submit" class="btn font-balo font-bold">
                            {{ $t("app.Send") }}
                        </button>
                    </div>
                </form>
            </ValidationObserver>
        </div>
    </main>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapActions, mapState } from "vuex";
import { pick, get } from "lodash";
import VueRecaptcha from "vue-recaptcha";
import { siteKey } from "@/helper/config";
import ClickOutside from "vue-click-outside";
import { setDescriptionPage } from "@/helper/helper";
export default {
    name: "ContactUsPage",
    components: {
        ValidationProvider,
        ValidationObserver,
        VueRecaptcha
    },
    data() {
        return {
            contact_name: "",
            contact_email: "",
            contact_message: "",
            contact_camping: "",
            verifyCaptcha: false,
            siteKey: siteKey,
            isOpenDopdown: null
        };
    },
    mounted() {
        this.getCampingClubs();
        setDescriptionPage(get(this.general, "contact_page_metades"));
    },
    computed: {
        ...mapState({
            general: state => get(state, "app.general", {}),
            campingClubs: state => get(state, "campingClubs.list", [])
        })
    },
    methods: {
        ...mapActions("app", ["sendContact"]),
        ...mapActions("campingClubs", ["getCampingClubs"]),
        onSubmit() {
            if (this.verifyCaptcha) {
                this.sendContact({
                    ...pick(this, [
                        "contact_name",
                        "contact_email",
                        "contact_message",
                        "contact_camping"
                    ])
                }).then(() => {
                    this.$bvToast.toast(
                        this.$i18n.t("app.Thank your for contact"),
                        {
                            title: this.$i18n.t("app.Successfully"),
                            variant: "success",
                            solid: true
                        }
                    );
                    this.clearForm();
                });
            }
        },
        clearForm() {
            this.contact_name = "";
            this.contact_email = "";
            this.contact_message = "";
            this.contact_camping = "";
            this.verifyCaptcha = false;
            this.$refs.form.reset();
            this.resetRecaptcha();
        },
        onSelectCamping(data) {
            this.contact_camping = data.title.rendered;
            this.isOpenDopdown = null;
        },
        onCaptchaVerified(response) {
            if (response) this.verifyCaptcha = true;
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset();
        },
        setIsOpenDropdown(key) {
            this.isOpenDopdown = this.isOpenDopdown !== key ? key : null;
        },
        clickOutSite() {
            this.isOpenDopdown = null;
        }
    },
    directives: {
        ClickOutside
    }
};
</script>
